
import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';
import Dest from '../Dest/Dest';
import ExternalSources from '../ExternalSources/ExternalSources';
import Faq from '../Faq/Faq';
import Menu from '../Menu/Menu';
import SpostaNodo from '../SpostaNodo/SpostaNodo';
import './GestioneAlbero.css';

function GestioneAlbero(props) {

    const [bundle_it, setBundle_it] = useState("");
    const [bundle_en, setBundle_en] = useState("");

    const [modifiedNodes, setModifiedNodes] = useState([]);

    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedNode, setSelectedNode] = useState(props.selectedNode);

    // Sync selectedNode state with props.selectedNode (props update from parent)
    useEffect(() => {
        setSelectedNode(props.selectedNode);
    }, [props.selectedNode]);

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    const reject = () => {

    };

    const confirmOperation = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: getText("CONFERMA_OPERAZIONE"),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: eliminaNodo,
            reject: reject
        });
    };

    useEffect(() => {
        console.log("selectedNode", props.selectedNode)
    }, [props.selectedNode]);


    const iconScheduled = "pi pi-clock";
    const iconHidden = "pi pi-eye-slash";
    const iconVisible = "pi pi-eye";
    const iconExpired = "pi pi-exclamation-circle";


    useEffect(() => {

        let questions = [];
        if (props.faqs != null && props.faqs.length > 0) {
            props.faqs.forEach((faq) => {
                if (faq.icon === iconScheduled || faq.icon === iconHidden || faq.icon === iconVisible || faq.icon === iconExpired) {
                    let question = {
                        value: faq.key,
                        label: "" + faq.label,
                        icon: faq.icon
                    }
                    questions.push(question);
                } else if (faq.icon === "pi pi-folder") {

                    faq.children.map((inner) => {
                        if (inner.icon === iconScheduled || inner.icon === iconHidden || inner.icon === iconVisible || inner.icon === iconExpired) {
                            let question = {
                                value: inner.key,
                                label: inner.label,
                                icon: inner.icon
                            }
                            questions.push(question);
                        }
                    })
                }

            })
        }
        setQuestions(questions);

    }, [props.faqs]);

    const salvaTutto = (operation) => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            if(operation != null && operation === "allegati" && operation==="authRequired") {
                let selNode = selectedNode;
                selNode.attachments = !selNode.attachments;
                setSelectedNode(selNode);
            }else{
                props.onSave(props.tematica, true);
            }
            
            setModifiedNodes([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
        });
    }

    const aggiungiMenu = () => {

        var item = {
            is_new: true,
            id_tree: "jstree_tematica",
            obj_type: "menu",
            op_type: "add_br",
            position: 6,
            id_item_parent: 0,
            id_item: 0,
            id_node_parent: 0,
            bundle_en: bundle_en,
            bundle_it: bundle_it
        }
        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }

    const eliminaNodo = () => {

        var item = {
            is_new: false,
            id_tree: "jstree_tematica",
            op_type: "del",
            id_item: selectedNode.idItem,
            id_item_parent: selectedNode.idItemParent,
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }

    const onSave = (tematica, outcome) => {
        props.onSave(tematica, outcome);
    }

    const onNodeLoaded = () => {
        props.onNodeLoaded();
    }

    const onModificationReceived = (item) => {
        props.onModificationReceived(item);
    }

    const inibisciAllegati = () => {
        var modifiedItem = { is_new: false, id_item: selectedNode.idItem, id_element: "allegati", op_type: "mod_el", obj_type: "menu", new_val: false }
        modifiedNodes.push(modifiedItem)
        setModifiedNodes(modifiedNodes)

        salvaTutto("allegati");

    }

    const consentiAllegati = () => {
        var modifiedItem = { is_new: false, id_item: selectedNode.idItem, id_element: "allegati", op_type: "mod_el", obj_type: "menu", new_val: true }
        modifiedNodes.push(modifiedItem)
        setModifiedNodes(modifiedNodes)

        salvaTutto("allegati");
    }

    // --- Login richiesto / Auth_Required ---
    const abilitaLoginRequired = () => {
        var modifiedItem = { is_new: false, id_item: selectedNode.idItem, id_element: "auth_required", op_type: "mod_el", obj_type: "menu", new_val: true }
        modifiedNodes.push(modifiedItem)
        setModifiedNodes(modifiedNodes)

        let selNode = { ...selectedNode, authRequired: true };
        setSelectedNode(selNode);

        salvaTutto("authRequired");
    }

    const disabilitaLoginRequired = () => {
        var modifiedItem = { is_new: false, id_item: selectedNode.idItem, id_element: "auth_required", op_type: "mod_el", obj_type: "menu", new_val: false }
        modifiedNodes.push(modifiedItem)
        setModifiedNodes(modifiedNodes)

        let selNode = { ...selectedNode, authRequired: false };
        setSelectedNode(selNode);

        salvaTutto("authRequired");
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }
            {!loading &&
                <>
                    <ConfirmPopup />
                    {props.root &&
                        <>
                            <p style={{ textAlign: "left" }}>
                                {getText("INSERISCI_MENU")}
                            </p>



                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-4">
                                    Testo in Italiano
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_it} onChange={(e) => setBundle_it(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-4">
                                    Testo in Inglese
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="menu" value={bundle_en} onChange={(e) => setBundle_en(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-2">
                                    <Button onClick={aggiungiMenu} icon="pi pi-plus" label={getText("AGGIUNGI")} />
                                </div>
                            </div>

                        </>

                    }
                    {!props.root &&
                        <div className="p-fluid grid">
                            <div className="field col-12 md:col-12">
                                <SpostaNodo selectedNode={selectedNode} onSave={onSave} tematica={props.tematica} />
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                            </div>

                            {selectedNode.nodeType === "M" &&
                                <div className="field col-12 md:col-12">
                                    <ExternalSources selectedNode={selectedNode} onSave={onSave} tematica={props.tematica} />
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                </div>
                            }

                            {selectedNode.nodeType === "M" &&
                                <div className="field col-12 md:col-12">
                                    <Menu onSave={onSave} tematica={props.tematica} idConfig={props.idConfig} selectedNode={selectedNode} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} onConfirmOperation={confirmOperation} />
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                </div>
                            }
                            <br />
                            {selectedNode.nodeType === "Q" &&
                                <div className=" col-12 md:col-12">
                                    <div>&nbsp;</div>
                                    <Faq isNew={false} allowDelete onSave={onSave} tematica={props.tematica} idConfig={props.idConfig} selectedNode={selectedNode} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} onConfirmOperation={confirmOperation} />
                                </div>
                            }
                            {selectedNode.nodeType === "D" &&
                                <div className=" col-12 md:col-12">
                                    <div>&nbsp;</div>
                                    <Dest isNew={false} onSave={onSave} tematica={props.tematica} idConfig={props.idConfig} selectedNode={selectedNode} onNodeLoaded={onNodeLoaded} onModificationReceived={onModificationReceived} onConfirmOperation={confirmOperation} />
                                </div>
                            }
                            {(selectedNode.nodeType === "M") &&
                                <div className="formgroup-inline col-12 md:col-12">
                                    <div className="col-4 md:col-4">
                                        {selectedNode.attachments ? getText("INIBISCI_ALLEGATI") : getText("CONSENTI_ALLEGATI")}
                                        <InputSwitch checked={selectedNode.attachments} onChange={selectedNode.attachments ? inibisciAllegati : consentiAllegati} />
                                    </div>
                                    <div className="col-4 md:col-4">
                                        {selectedNode.authRequired ? getText("LOGIN_REQUIRED_ON") : getText("LOGIN_REQUIRED_OFF")}
                                        <InputSwitch checked={selectedNode.authRequired} onChange={selectedNode.authRequired ? disabilitaLoginRequired : abilitaLoginRequired} />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </>
            }
        </>

    )
}

export default GestioneAlbero
